module.exports = __webpack_public_path__ + "assets/add-value.3670529e.svg";